import React, { useState } from 'react';
import { GenericFilter, SortOption } from '../generic-filter/GenericFilter';

export interface ScopeFilterValues {
  searchText: string;
  sortBy: string;
  sortDirection: "asc" | "desc";
}

interface ScopeFilterProps {
  onFilterChange: (filters: ScopeFilterValues) => void;
}

const sortOptions: SortOption[] = [
  { value: "name", label: "Name" },
  { value: "consentMessage", label: "Consent Message" },
  { value: "alwaysShowConsent", label: "Always Show Consent" },
];

export const ScopeFilter: React.FC<ScopeFilterProps> = ({ onFilterChange }) => {
  const [filters, setFilters] = useState<ScopeFilterValues>({
    searchText: '',
    sortBy: 'name',
    sortDirection: 'asc',
  });

  const handleSearch = (searchText?: string) => {
    const newFilters = {
      ...filters,
      searchText: searchText || '',
    };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const handleSortChange = (sortBy: string) => {
    const newFilters = {
      ...filters,
      sortBy,
    };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const handleSortDirectionChange = (sortDirection: "asc" | "desc") => {
    const newFilters = {
      ...filters,
      sortDirection,
    };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  return (
    <GenericFilter
      onSearch={handleSearch}
      onSortChange={handleSortChange}
      onSortDirectionChange={handleSortDirectionChange}
      sortOptions={sortOptions}
      placeholder="Search Scopes"
      ariaLabel="Search Scopes"
      sortBy={filters.sortBy}
      sortDirection={filters.sortDirection}
    />
  );
};